import { Component } from '@angular/core';

@Component({
  selector: 'uni-widget-header',
  templateUrl: './uni-widget-header.component.html',
  styleUrls: ['./uni-widget-header.component.scss'],
})
export class UniWidgetHeaderComponent {
}
